import { PlanType } from "../api/accounts/getWarehousePlans";
import { TPlanJsonConfig } from "./save";

document.querySelectorAll(".wp-block-usgm-plans").forEach(function (block) {
    const plansList = block.querySelector(".plans-list");
    const jsonConfig = block.getAttribute("data-plans");
    const config = (
        jsonConfig ? JSON.parse(jsonConfig) : {}
    ) as TPlanJsonConfig;

    const planCards = block.querySelectorAll(".plan-card");
    planCards.forEach((card) => {
        card.addEventListener("click", function () {
            window.location.href =
                card.querySelector("a")?.getAttribute("href") || "";
        });
    });
    block
        .querySelector(".switch input")
        ?.addEventListener("change", function (e) {
            const target = e.target as HTMLInputElement;
            const action = !target.checked ? "add" : "remove";
            plansList?.classList[action]("term-monthly");
            block.classList[action]("term-monthly");
            planCards.forEach((card) => {
                const type = card.getAttribute("data-type") as PlanType;
                const priceInfo = config.plans?.find(
                    (plan) => plan.type === type,
                );
                const priceElement = card.querySelector(".price");
                if (priceElement) {
                    priceElement.innerHTML = `$${
                        target.checked
                            ? priceInfo?.price?.annually
                            : priceInfo?.price?.monthly
                    }/mo`;
                }
                card.querySelectorAll(".actions-container a").forEach(
                    (link) => {
                        const href = link.getAttribute("href");
                        if (href) {
                            link.setAttribute(
                                "href",
                                href.replace(
                                    /term_id=\{[0-9]+\}/,
                                    `term_id={${target.checked ? 1 : 12}}`,
                                ),
                            );
                        }
                    },
                );
            });
        });
});
